import { Select } from 'antd';
import { useEffect } from 'react';
import { DataSelectBox } from '../../models/selectbox';

const TrangThaiNhanVienSelectBox = ({ value, disabled, onChange }: { value?: number, disabled?: boolean, onChange: (e: any) => void }) => {
    const data: Array<DataSelectBox> = [
        {
            value: 1,
            label: "Đang làm việc"
        },
        {
            value: 2,
            label: "Chuyển công tác"
        },
        {
            value: 4,
            label: "Đã nghỉ hưu"
        },
        {
            value: 3,
            label: "Đã nghỉ việc"
        },
    ];

    useEffect(() => {
        onChange({
            target: {
                value: value
            }
        })
    }, []);

    return (
        <Select
            style={{ width: '100%' }}
            showSearch
            placeholder="--Chọn trạng thái nhân viên--"
            value={value}
            options={data}
            onChange={(e: number) => {
                onChange({
                    target: {
                        value: e
                    }
                })
            }}
            disabled={disabled}
        />
    );
};

export default TrangThaiNhanVienSelectBox;
